/**
 * Довідник пільг ОСЦПВ. Джерело — бекенд (GET /api/privilege-types, App\Models\PrivilegeList).
 *
 * Елемент: { id, key, name, value, text, document, documentUid, selectable }
 *  - id/name(key) — внутрішній id та ключ ('retired', 'war', …);
 *  - value — назва пільги, text — назва документа, documentUid — id типу документа;
 *  - selectable — чи показувати у виборі (false для «без пільг» і е-пенсіонера).
 *
 * Список мутується на місці (splice), щоб компоненти, які скопіювали посилання
 * на масив у created(), побачили дані після завантаження.
 */
const state = {
    all: [],
    list: [],
    loaded: false,
};

let loadingPromise = null;

const getters = {
    CUSTOMER_PRIVILEGE: state => state.list,
    CUSTOMER_PRIVILEGE_ALL: state => state.all,
    CUSTOMER_PRIVILEGE_LOADED: state => state.loaded,
};

const actions = {
    loadPrivilegeTypes({ commit, state }) {
        if (state.loaded) {
            return Promise.resolve(state.list);
        }
        if (loadingPromise) {
            return loadingPromise;
        }

        loadingPromise = axios.get('/api/privilege-types')
            .then(response => {
                const items = response?.data?.data ?? [];
                commit('SET_PRIVILEGE_TYPES', items);
                return state.list;
            })
            .finally(() => {
                loadingPromise = null;
            });

        return loadingPromise;
    },
};

const mutations = {
    SET_PRIVILEGE_TYPES: (state, items) => {
        state.all.splice(0, state.all.length, ...items);
        state.list.splice(0, state.list.length, ...items.filter(item => item.selectable));
        state.loaded = true;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
